import { Component, OnInit, Input, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DateInputDialogData {
  title: string;
  parentForm: UntypedFormGroup;
  dateInputPlaceholder: string;
}

@Component({
    selector: 'odq-date-input-dialog',
    templateUrl: './date-input-dialog.component.html',
    styleUrls: ['./date-input-dialog.component.scss'],
    standalone: false
})
export class DateInputDialogComponent implements OnInit {

  form = new UntypedFormGroup({
    date: new UntypedFormControl('', Validators.required),
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: DateInputDialogData) { }

  ngOnInit() {
  }

}
